import {FilteringFlow} from "@filtering.js/filtering.js/ui"

export default (el) => {
  class Variant extends FilteringFlow {
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    }

    updatePrice(items) {
      let hasStore = false
      let hasOnline = false

      for (let item of items) {
        let element = item.data.element
        let buyValue = element.getAttribute('data-filter-buy')
        let salePriceValue = element.getAttribute('data-price-sale_price')
        let promotionPriceValue = element.getAttribute('data-price-promotion_price')

        if (buyValue === '0') {
          el.querySelector('.js-store-price-promotion').innerHTML = promotionPriceValue
          el.querySelector('.js-store-price-sale').innerHTML = this.numberWithCommas(salePriceValue) + 'đ'
          hasStore = true
        }

        if (buyValue === '1') {
          el.querySelector('.js-online-price-promotion').innerHTML = promotionPriceValue
          el.querySelector('.js-online-price-sale').innerHTML = this.numberWithCommas(salePriceValue) + 'đ'
          hasOnline = true
        }

        if (hasStore && hasOnline) {
          break
        }
      }
    }

    beforeFilter(filterElement) {
      // Reset price in group buy
      document.querySelector('.filtering-group-buy').querySelectorAll('.filtering-filter').forEach(function (i) {
        i.classList.remove('checked')
      })

      return true
    }

    handleFilterResult(result) {
      super.handleFilterResult(result)
      let items = result.filteredItems
      let variant = items[0].data.element
      let variantId = variant.id
      let productId = variant.getAttribute('data-product-id')
      // console.log(variantId)

      this.updatePrice(items)

      // Location required
      document.querySelector('.filtering-group-location').querySelectorAll('.filtering-filter').forEach(function (i) {
        if (i.classList.contains('checked')) {
          i.classList.add('pe-none')
        }
        else {
          i.classList.remove('pe-none')
        }
      })

      // Price required
      let shouldSkip = false
      document.querySelector('.filtering-group-buy').querySelectorAll('.filtering-filter').forEach(function (i) {
        if (i.classList.contains('checked')) {
          i.classList.add('pe-none')
          shouldSkip = true
        }
        else {
          i.classList.remove('pe-none')
        }
      })

      // Set price default
      try {
        document.querySelector('.filtering-group-buy').querySelectorAll('.filtering-filter').forEach(function (i) {
          if (!i.classList.contains('disabled') && !shouldSkip) {
            i.classList.add('checked')
            throw {}
          }
        })
      } catch (e) {}


      // Send Ajax
      $.post(VariationSwatchesData.ajaxUrl, {
        action: 'variation_swatches',
        id: productId,
        variation: variantId,
        nonce: VariationSwatchesData.nonce
      }).done(function (result) {
        let {price, order_button_full, order_button_small} = result.data

        $('.price-format-range').replaceWith(price)
        $('.price-format-full').replaceWith(price)
        $('.order-button-full').replaceWith(order_button_full)
        $('.order-button-small').replaceWith(order_button_small)

        // Trigger gallery
        $(document).trigger("dp_variation", [result.data]);
      });
    }
  }

  new Variant(document.querySelector('#variant'))
}
